export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://api.irgoperations.com/";

export const ROLES = {
  ADMIN:    "admin",
  EMPLOYEE: "user",
  HR:       "hr",
  MANAGER:  "manager",
};

export const RECORD_CATEGORIES = {
  WARM: 1,
  COLD: 2,
};
